export enum WidgetsTypes {
  FLIGHTS = 'FLIGHTS',
  HOTELS = 'HOTELS'
}
